// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"09df3693","160":"18365f24","208":"3d0c1cb4","293":"b813bc08","453":"54292a4b","516":"ce32d62c","519":"61810f9d","917":"4f3f6524","946":"c5226876"}[chunkId] + ".chunk.js";
};